import type { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { CallUs } from '$quantum/molecules/CallUs';
import VrmLookup from '$quantum/molecules/VrmLookup';
import type { AnyObject } from '$util/types';
import Styled from './styled';

export interface VrmLookupCardProps extends HTMLAttributes<HTMLDivElement> {
  readonly disabled?: boolean;
  readonly extraParams?: AnyObject;
  readonly vrm?: string;
  readonly sku?: string;
  readonly postcode?: string;
  readonly isFree?: boolean;
  readonly showCallUs?: boolean;
  readonly isFromErrorPage?: boolean;
}

export function VrmLookupCard({
  disabled,
  extraParams,
  vrm,
  postcode,
  isFree,
  isFromErrorPage,
  showCallUs = true,
  className,
  sku,
  ...props
}: VrmLookupCardProps): JSX.Element {
  return (
    <Styled {...props} className={classNames('VrmLookupCard', className)}>
      <VrmLookup
        disabled={disabled}
        extraParams={extraParams}
        vrm={vrm}
        sku={sku}
        postcode={postcode}
        isFree={isFree}
        isFromErrorPage={isFromErrorPage}
      />
      {showCallUs && <CallUs />}
    </Styled>
  );
}

VrmLookupCard.displayName = 'VrmLookupCard';
